/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import useLogin from "../../hooks/useLogin";
import AuthLayout from "../../components/Auth/AuthLayout";
import TextField from "../../components/Auth/TextField";
import PasswordField from "../../components/Auth/PasswordField";
import SubmitButton from "../../components/Auth/SubmitButton";

export default function Login() {
  const navigate = useNavigate();
  const { login, error, message, isLoggedIn } = useLogin();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) =>
    setForm((actual) => ({ ...actual, [e.target.name]: e.target.value }));

  const iniciarSesion = (e) => {
    e.preventDefault();

    if (form.email.trim() === "" || form.password === "") {
      Swal.fire({
        icon: "warning",
        title: "Faltan datos",
        text: "Escribe tu correo y tu contraseña para entrar.",
      });
      return;
    }

    setLoading(true);
    login(form);
  };

  useEffect(() => {
    if (error) {
      setLoading(false);
      Swal.fire({ icon: "error", title: "No pudimos entrar", text: message });
    }
  }, [error]);

  useEffect(() => {
    if (isLoggedIn) {
      setLoading(false);
      navigate("/");
    }
  }, [isLoggedIn]);

  // Sin enlace de "crear cuenta": las cuentas las da de alta un administrador
  // desde dentro del sistema, en la pantalla de Usuarios.
  return (
    <AuthLayout title="Bienvenido a LCI">
      <form onSubmit={iniciarSesion} noValidate>
        <TextField
          id="email"
          label="Correo electrónico"
          type="email"
          value={form.email}
          onChange={handleChange}
          autoComplete="email"
          inputMode="email"
          autoFocus
        />

        <PasswordField value={form.password} onChange={handleChange} />

        <div className="auth-aside">
          <Link className="auth-link" to="/forgot-password">
            ¿Olvidaste tu contraseña?
          </Link>
        </div>

        <SubmitButton loading={loading} loadingLabel="Entrando...">
          Entrar
        </SubmitButton>
      </form>
    </AuthLayout>
  );
}
